import { useMutation } from "@apollo/client";

import { STAND_KEY_CREATE } from "graphql/mutation/stand-gql";

import { successNotification, errorNotification } from "components/request-result";


const useMutationStandKeyCreate = (stand) => {


    const [ _setStandKeyCreate, { loading } ] = useMutation(STAND_KEY_CREATE,
        {
            update(cache, { data }) {

                const {
                    standKeyCreate: {
                        label,
                        message,
                        stand: {
                            keys: {
                                title,
                                number
                            }
                        }

                    }
                } = data;


                cache.modify({
                    id: cache.identify(stand),
                    fields: {
                        title() {
                            return title;
                        },
                        number() {
                            return number;
                        },
                    },
                });

                successNotification({
                    title: label,
                    description: message
                });
            },
            onError(error) {
                errorNotification(error);
            }
        }
    );



    return {
        _setStandKeyCreate,
        loadingMutationStandKeyCreate: loading,
    }
};

export default useMutationStandKeyCreate;

